<template>
  <div class="article" v-if="article" :data-tcm-id="article.tcm">
    <a v-if="articleLink" :href="articleLink" class="article_link"></a>
    <b-card
      overlay
      tag="article"
      :class="`mb-2 article_${type}`"
      no-body
    >
    <b-img-lazy :src="articleImage.src" :alt="articleImage.alt" fluid></b-img-lazy>

      <b-card-title class="article-description">
          <div class="article-category mb-2 text-12 font-weight-bold color-primary">{{ article.category?article.category:article.type.description }}</div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="mb-2 text-16 font-weight-bold article-title">{{ article.title }} </div>
            <i v-if="articleLink && type!=='promoted'" class="icon-arrow-right xs color-primary"></i>
          </div>
          <div v-if="type!=='promoted'" class="description-text show-on-hover">{{ article.description }}</div>
      </b-card-title>
    <div class="time-read px-3 py-2 text-12" v-if="article.timeToRead || article.time"> <i class="icon-clock-desk xs icon-right"></i> {{translate('bgMinToRead', undefined, article.timeToRead?article.timeToRead:article.time)}}</div>
    </b-card>
  </div>
</template>

<script>
import { translate } from 'rhg-vue-common'
export default {
  name: 'ArticleComponent',
  props: {
    article: Object,
    type: String
  },
  data () {
    return {
      showDescription: false
    }
  },
  methods: {
    translate
  },
  computed: {
    articleImage () {
      let src = ''
      let alt = ''
      const impolicyCard = '?impolicy=Card'
      const impolicyGalleryLightbox = '?impolicy=GalleryLightbox'
      if (this.type === 'article-3') {
        src = `${this.article.image.url}${impolicyCard}`
        alt = this.article.image.altText
      } else if (this.type === 'article-2') {
        src = this.article.imageTwoColumn ? `${this.article.imageTwoColumn.url}${impolicyCard}` : `${this.article.image.url}${impolicyCard}`
        alt = this.article.imageTwoColumn ? this.article.imageTwoColumn.altText : this.article.image.altText
      } else if (this.type === 'article-1') {
        src = this.article.imageOneColumn ? `${this.article.imageOneColumn.url}${impolicyGalleryLightbox}` : `${this.article.image.url}${impolicyGalleryLightbox}`
        alt = this.article.imageOneColumn ? this.article.imageOneColumn.altText : this.article.image.altText
      } else {
        src = `${this.article.image.url}${impolicyCard}`
        alt = this.article.image.alt
      }
      return {
        src, alt
      }
    },
    articleLink () {
      const { seo, link } = this.article

      return seo || link
    }
  }
}
</script>
<style lang="scss" scoped>

.article_link{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  color: unset;
  z-index: 100;
}
.article{
  position: relative;
  border-radius: 8px;
  img{
    border-radius: 8px;
  }
  .card{
    border: 1px solid #ECECEC;
    background-color: unset!important;
    border-radius: 8px;
    height: auto!important;
    box-shadow: unset!important;
    .card-title{
      margin-bottom: unset!important;
    }
  }
    .article-description{
      opacity: 0.95;
      border-radius: 8px;
      background-color: white;
      position: absolute;
      bottom: 0px;
      padding: 20px;
      width: 100%;
      left: 0;
      overflow: hidden;
      min-height: 111px;
    .article-title{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;  /* limit to 2 lines */
      min-height: 2em;
    }
    .article-category{
      text-transform: uppercase;
      color: #C20808;
    }
    .description-text{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;  /* limit to 2 lines */
    }
    .show-on-hover{
      transition: height 0.2s ease-in;
      height: 1px;
    }

  }
  &:hover{
    .article-description{
      opacity: 1;
    }
    .show-on-hover{
      transition: height 0.2s ease-out;
      height: 3em;
    }
  }
  .article_promoted{
    max-width: 340px;
    img{
      max-height: 302px;
      border-radius: 8px;
    }
    .article-description{
      bottom: 0px;
      opacity: 0.95;
    }
  }
  .time-read{
    position: absolute;
    top: 20px;
    left: 25px;
    border: 1px solid transparent;
    border-radius: 20px;
    background: #f1f1f1;
    color: #6A6B6F;
  }
  img{
    height: 357px;
    object-fit: cover;
  }
}
</style>
